/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Box, Typography, Avatar } from '@mui/material';
import './ClaimsARModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import { themes } from '../../../themes/themes';
import TakeActionSplitBtn from '../../../components/TakeActionSplitBtn/TakeActionSplitBtn';
import LeaveHistoryArTile from '../../../components/LeaveHistoryTileAr/LeaveHistoryTileAr';
import { getAmount } from '../../../configs/utils';
import { DateField } from '../../../../components';
import { baseDateFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  historyData?: any;
  fullData?: any;
  allActions?: any;
  userId?: any;
  handleSubmitAR_Request?: any;
}

const ClaimsARModalPresenter = ({
  isModalOpen,
  closeModal,
  fullData,
  historyData,
  trans,
  allActions,
  handleSubmitAR_Request,
  userId,
}: ModalProps) => {
  const getStatus = ['Pending', 'Approved', 'Rejected'];

  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: 'claims',
        instanceId: fullData?.id,
        userId: userId,
        action: x ? x : '',
        context: {},
        model: 'emp_claims',
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="35vw">
      <ModalHeader
        modal={{ modal_title: trans('Claims Action Required') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '5px',
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar_claim">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: '10px' }}>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.darkBlue,
                      fontSize: '1em',
                      fontWeight: 'bold',
                    }}
                  >
                    {fullData?.first_name + ' ' + fullData?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      color: themes.grey_colorDesignationAR,
                      fontSize: '0.825em',
                    }}
                  >
                    {fullData?.department_name} / {fullData?.designation_name}
                  </Typography>
                </Box>
              </Box>

              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Applied On
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    <DateField value={fullData?.appliedOn} format={baseDateFormatting} />
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Type
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.defaultScondary_blue,
                    }}
                  >
                    {fullData?.type}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Amount
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: themes.primaryMain,
                      padding: '4px',
                      borderRadius: '4px',
                      backgroundColor: '#F2E6F0',
                    }}
                  >
                    {getAmount(fullData?.amount)}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  padding: '1em',
                  marginTop: '0.5em',
                  width: 'auto',
                  backgroundColor: '#F5F5FA66',
                  height: '30px',
                  flexDirection: 'column',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginTop: '5px',
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: 'Lato',
                      fontSize: '12px',
                      color: themes.greyModalTitle,
                    }}
                  >
                    Attachment
                  </Typography>
                  <Box>
                    <i className="las la-eye" color={themes.primary} />
                  </Box>
                </Box>
              </Box>

              <Box style={{ marginTop: '1.5em' }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: '1.5em', zIndex: '999', width: '100%' }}>
                <TakeActionSplitBtn
                  onAction={(x: any) => handleTakeAction(x)}
                  menu={allActions}
                  title={'Take Action'}
                />
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}
          <Grid item xs={6}>
            <Box className="bg_border_ar_claim">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.primaryMain,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  Claim History
                </Typography>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  style={{
                    fontFamily: 'Lato',
                    color: themes.greySubtitle,
                    fontSize: '0.875em',
                    fontWeight: 'bold',
                  }}
                >
                  Claim Type:{' '}
                  <span style={{ color: themes.defaultScondary_blue }}>
                    All
                  </span>
                </Typography>
                <Box
                  style={{
                    border: '1px solid #979797',
                    borderRadius: '4px',
                    alignSelf: 'center',
                    padding: '8px',
                    cursor: 'pointer',
                  }}
                >
                  <i className="las la-filter" color="#464545" />
                </Box>
              </Box>
              {historyData?.length > 0 &&
                historyData?.map((data: any, index: any) => {
                  return (
                    <div key={index}>
                      <LeaveHistoryArTile
                        actorName={''}
                        date1={data?.date}
                        dayOrAmount={getAmount(data?.amount)}
                        remarks={data?.description}
                        status={getStatus[data?.status]}
                        typeName={data?.claim_type?.name}
                      />
                    </div>
                  );
                })}
            </Box>
          </Grid>
          {/* {Third Column} */}
          {/* <Grid item xs={4}>
            <Box className="bg_border_ar_claim">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    color: themes.primaryMain,
                    fontSize: "0.875em",
                    fontWeight: "bold",
                  }}
                >
                  Recent Applied
                </Typography>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    color: themes.greySubtitle,
                    fontSize: "0.875em",
                    fontWeight: "bold",
                  }}
                >
                  Department:{" "}
                  <span style={{ color: themes.defaultScondary_blue }}>
                    All
                  </span>
                </Typography>
                <Box
                  style={{
                    border: "1px solid #979797",
                    borderRadius: "4px",
                    alignSelf: "center",
                    padding: "8px",
                    cursor: "pointer",
                  }}
                >
                  <i className="las la-filter" color="#464545" />
                </Box>
              </Box>
              <EmployeeTicketHistoryARTile
                amount="AED 500"
                designation="Full Stack Developer"
                name="Khaqan Abbasi"
              />
              <EmployeeTicketHistoryARTile
                amount="AED 500"
                designation="Full Stack Developer"
                name="Khaqan Abbasi"
              />
            </Box>
          </Grid> */}

          {/* {Horizontals Steps Label} */}
          {/* <Grid item xs={12}>
            <Box
              style={{
                border: "1px solid #0000001f",
                padding: "10px",
                borderRadius: "10px",
              }}
            >
              <HorizontalStepperForActionRequired direction="horizontal" />
            </Box>
          </Grid> */}
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default ClaimsARModalPresenter;
